import { ButtonLink } from '@semcore/ui/button';
import Tooltip from '@semcore/ui/tooltip';
import { useTranslation } from 'react-i18next';

export const AnnouncementDisabledFileUpload = () => {
  const { t } = useTranslation(['common', 'mailings']);

  return (
    <div className="flex gap-1">
      <Tooltip
        className="w-fit"
        title={t(
          'mailings:personalizedMailingCreatorWizard.objectivesForm.fileUpload.disabledTooltip',
        )}>
        <ButtonLink
          disabled
          data-test="disabled-upload-document-link"
          size={300}
          use="primary">
          {t(
            'mailings:personalizedMailingCreatorWizard.objectivesForm.announcement.storyLink.uploadPressRelease',
          )}
        </ButtonLink>
      </Tooltip>
      {t('common:or')}

      <Tooltip
        className="w-fit"
        title={t(
          'mailings:personalizedMailingCreatorWizard.objectivesForm.announcement.storyLink.selectPressReleaseDisabledTooltip',
        )}>
        <ButtonLink
          disabled
          data-test="disabled-select-from-workspace-button"
          size={300}
          use="primary">
          {t(
            'mailings:personalizedMailingCreatorWizard.objectivesForm.announcement.storyLink.selectFromWorkspace',
          )}
        </ButtonLink>
      </Tooltip>
    </div>
  );
};
